import { supabase } from './config';

/**
 * Upload profile picture
 */
export const uploadProfilePicture = async (userId, file) => {
  try {
    const fileExt = file.name.split('.').pop();
    const fileName = `${userId}/profile_${Date.now()}.${fileExt}`;
    
    const { error } = await supabase.storage
      .from('profile-pictures')
      .upload(fileName, file, {
        cacheControl: '3600',
        upsert: true
      });
    
    if (error) {
      return { success: false, error: error.message };
    }
    
    const { data: urlData } = supabase.storage
      .from('profile-pictures')
      .getPublicUrl(fileName);
    
    return { 
      success: true, 
      url: urlData.publicUrl 
    };
  } catch (error) {
    return { 
      success: false, 
      error: error.message 
    };
  }
};

/**
 * Delete profile picture
 */
export const deleteProfilePicture = async (userId) => {
  try {
    const { error } = await supabase.storage
      .from('profile-pictures')
      .remove([`${userId}/profile.jpg`, `${userId}/profile.png`]);

    if (error) throw error;

    return { success: true };
  } catch (error) {
    console.error('Delete error:', error);
    return { success: false, error: error.message };
  }
};